// extracted by mini-css-extract-plugin
export default {"receiverUnreadItem":"index-module--receiverUnreadItem--70r3T","receiverUnreadItemIcon":"index-module--receiverUnreadItemIcon--ELTYP"};